import { StandardEvents } from '@shopify/events';

/**
 * MSH BOGO free-pair popup trigger.
 *
 * Decoupled from the shape of the theme's own cartLinesUpdate event detail
 * (which varies by consumer - see assets/header-actions.js vs.
 * assets/component-cart-items.js) by treating that event purely as a
 * "cart changed, go check" signal, then reading the authoritative cart
 * state straight from the public /cart.js endpoint.
 */

let lastBogoQuantity = null;

async function getBogoQuantity() {
  const response = await fetch('/cart.js');
  const cart = await response.json();
  return cart.items.reduce((total, item) => {
    const isBogo = item.properties && String(item.properties._bogo) === 'true';
    return isBogo ? total + item.quantity : total;
  }, 0);
}

async function handleCartLinesUpdate() {
  const quantity = await getBogoQuantity();

  // Fires on an increase that lands on an ODD total (1, 3, 5...), which is the
  // moment the shopper is one pair short of a complete free-pair set - so the
  // popup is an invitation to claim the NEXT pair free, not a receipt for one
  // they already got.
  //
  // FLIPPED 2026-09-04 (May: "the pop up GET Your FREE Pair should come out at
  // the even numbers 2nd, 4th, 6th after adding to cart 1st, 3rd, 5th").
  // Previously this fired on even totals, which meant it appeared only AFTER
  // the shopper had already added the free pair - too late to persuade anyone
  // of anything. Odd is the persuadable moment.
  //
  // Still guarded so it never fires on a REMOVAL that happens to leave an odd
  // total (quantity > lastBogoQuantity), nor on a page's very first load
  // (lastBogoQuantity still null).
  if (lastBogoQuantity !== null && quantity > lastBogoQuantity && quantity % 2 === 1) {
    document.getElementById('msh-bogo-popup')?.showDialog();
  }

  lastBogoQuantity = quantity;
}

document.addEventListener(StandardEvents.cartLinesUpdate, handleCartLinesUpdate);

// Seed the baseline from whatever's already in the cart on page load, silently.
getBogoQuantity().then((quantity) => {
  lastBogoQuantity = quantity;
});
